import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ComplianceDataPrivacyService } from '../../services/compliance.dataprivacy.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { DataPrivacySummaryRepo } from '@client/app/modules/data-privacy/services/api/summary_repo';
import { SessionService } from '@monsido/core/session/session.service';

@Component({
    selector: 'domain-dashboard-data-privacy',
    template: `
        <div class="card panel-monsido-card max-height d-flex flex-column">
            <a class="p-0" uiSref="base.customer.domain.data_privacy.summary" [attr.aria-label]="'Data Privacy' | translate">
                <mon-panel-header pHeader="{{ 'Data Privacy' | translate}}"
                                  data-test="data-privacy-card-heading">
                    <div class="text-right">
                        <div class="btn btn-link">
                            <span class="pl-1 fas fa-chevron-right" aria-hidden="true"></span>
                        </div>
                    </div>
                </mon-panel-header>
            </a>
            <div class="card-body flex-grow-1 row d-flex align-items-stretch">
                <div class="col-48">
                    <mon-spinner [loading]="loading">
                        <div class="row my-3">
                            <div class="offset-4 col-18">
                                <mon-chart-doughnut [data]="doughnutData"
                                                    [options]="doughnutOptions"
                                                    [colors]="chartColors">
                                </mon-chart-doughnut>
                            </div>
                            <div class="col-26">
                                <div class="row">
                                    <div class="vcenter col-48 mb-4 px-0">
                                        <notification-change tooltipTitle="{{'Contains high, medium & low severity issues for all pages' | translate}}"
                                                             title="{{'Data Privacy Issues' | translate }}"
                                                             [digit]="summaryData?.page_violation_active_counts.total"
                                                             unit="">
                                        </notification-change>
                                    </div>
                                    <div class="col-48">
                                        <ul class="list-inline">
                                            <li [triggers]="'focus hover'" [ngbTooltip]="'High severity issues' | translate">
                                                <a ui-sref="base.customer.domain.data_privacy.issues"
                                                   class="text-black"
                                                   [attr.aria-label]="'Go to data issues' | translate">
                                                    <span class="fas fa-circle high"></span>
                                                    <span class="sr-only" translate>High severity issues</span>
                                                    <span>{{summaryData?.page_violation_active_counts.high | monNumber}}</span>
                                                </a>
                                            </li>
                                            <li [triggers]="'focus hover'" [ngbTooltip]="'Medium severity issues' | translate">
                                                <a uiSref="base.customer.domain.data_privacy.issues"
                                                   class="text-black"
                                                   [attr.aria-label]="'Go to data issues' | translate">
                                                    <span class="fas fa-circle medium"></span>
                                                    <span class="sr-only" translate>Medium severity issues</span>
                                                    <span>{{summaryData?.page_violation_active_counts.medium | monNumber}}</span>
                                                </a>
                                            </li>
                                            <li [triggers]="'focus hover'" [ngbTooltip]="'Low severity issues' | translate">
                                                <a ui-sref="base.customer.domain.data_privacy.issues"
                                                   class="text-black"
                                                   [attr.aria-label]="'Go to data issues' | translate">
                                                    <span class="fas fa-circle low"></span>
                                                    <span class="sr-only" translate>Low severity issues</span>
                                                    <span>{{summaryData?.page_violation_active_counts.low | monNumber}}</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mon-spinner>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})

export class DomainDashboardDataPrivacyComponent implements OnInit {
    loading = false;
    progress: any;
    summaryData: any;
    chartColors: string[] = [];
    doughnutData: any;
    doughnutOptions: any;

    constructor (
        private gettextCatalog: TranslateService,
        private ng2DataPrivacySummaryRepo: DataPrivacySummaryRepo,
        private ng2PipeService: PipeService,
        private ng2SessionService: SessionService,
        private ng2ComplianceDataPrivacyService: ComplianceDataPrivacyService,
    ) {}

    ngOnInit () {
        this.loading = true;
        this.getPage();
    }

    getPage () {
        if (!this.ng2SessionService.domain?.id) {
            return;
        }
        this.progress = this.ng2DataPrivacySummaryRepo.getSummary(this.ng2SessionService.domain?.id).then((summary) => {
            this.summaryData = summary;
            this.setupChart(this.summaryData);
            this.loading = false;
        }, () => {});
    }

    setupChart (summary) {
        this.chartColors = ['#4dc0bd', '#dcdcdc'];
        const percentage = this.ng2ComplianceDataPrivacyService.dataPrivacyCompliancePercentage(summary);
        this.doughnutData = this.ng2ComplianceDataPrivacyService.dataPrivacyCompliance(summary);
        this.doughnutOptions = {
            centerText: {
                percentageLabel: this.ng2PipeService.get('monNumber')(percentage / 100, '0.[00] %'),
                totalLabel: this.gettextCatalog.getString('Overall compliance'),
                subLabel: this.gettextCatalog.getString('achieved'),
                totalFontSize: 150,
                subFontSize: 150,
            },
            cutoutPercentage: 80,
            tooltips: {
                enabled: false,
            },
            hover: {
                mode: null,
            },
        };
    }
}
